import { EditorState } from '@tiptap/pm/state';
import { getActiveBlock, findParentRow, isLastChildOf } from './rowUtils';

export const isInRow = (state: EditorState): boolean => {
  const info = getActiveBlock(state);
  return !!(info && findParentRow(state, info.pos));
};

export const canWrapLikeWord = (state: EditorState): boolean => {
  const info = getActiveBlock(state);
  if (!info) return false;
  const rowInfo = findParentRow(state, info.pos);
  if (!rowInfo) return true; // not in row → can wrap
  return isLastChildOf(rowInfo.node, info.pos, rowInfo.pos); // in row → only last item can wrap (pull next in)
};

export const canUnwrapLikeWord = (state: EditorState): boolean => {
  const info = getActiveBlock(state);
  if (!info) return false;
  const rowInfo = findParentRow(state, info.pos);
  if (!rowInfo) return false;
  return !isLastChildOf(rowInfo.node, info.pos, rowInfo.pos); // not last → can unwrap
};

/** Decide what the single button should do right now. */
export const getRowAction = (state: EditorState): { kind: 'wrap' | 'unwrap' | null; tooltip: string } => {
  if (canUnwrapLikeWord(state)) return { kind: 'unwrap', tooltip: 'Unwrap (split row or eject block)' };
  if (canWrapLikeWord(state)) return { kind: 'wrap', tooltip: 'Wrap (group with the element below)' };
  return { kind: null, tooltip: 'Wrap/Unwrap (not available here)' };
};
